import React, { useEffect, useState } from 'react';
import './CalculatorMobile.css';
import { t } from 'i18next';
import languageStore from '../../../store/languageStore';
import { useNavigate } from 'react-router-dom';

const CalculatorMobile = ({ favourites, onRemoveFavourite, clearAllLikes, setIsCalculatorVisible, isCalculatorExpanded }) => {

  const [selectedPass, setSelectedPass] = useState(null);
  const [gridClasses, setGridClasses] = useState([]);
  const [isCheckSavingTrue, setIsCheckSavingTrue] = useState(false);
  const [isCheckContinueTrue, setIsCheckContinueTrue] = useState(false);
  const [adultCount, setAdultCount] = useState(0);
  const [childrenCount, setChildrenCount] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [passes, setPasses] = useState(['1 DAY PASS', '2 DAY PASS', '3 DAY PASS', '4 DAY PASS', '5 DAY PASS', '6 DAY PASS', '7 DAY PASS', '10 DAY PASS'])
  const [passesAdult, setPassesAdult] = useState([0, 600, 500, 100, 100, 200, 200, 300])
  const [passesChild, setPassesChild] = useState([0, 400, 200, 200, 100, 100, 100, 200])
  const [selectedPassesIndex, setSelectedPassesIndex] = useState(null)
  const [isCalculatorOpen, setIsCalculatorOpen] = useState(false);

  const navigate = useNavigate();

  const capitalizeTitle = (title) => {
    if (title) {
      return title.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }
    return '';
  };

  useEffect(() => {
    const numRows = Math.ceil(passes.length / 3);
    const lastRowCount = passes.length % 3;

    const classes = Array(passes.length).fill('');
    if (lastRowCount > 0) {
      classes[passes.length - lastRowCount] = 'center';
    }

    setGridClasses(classes);
  }, [passes.length]);

  const updateTotalPrice = () => {
    const adultPrice = favourites.reduce((total, favourite) => {
      return total + (favourite.priceAdult ? Number(favourite.priceAdult) : 0) * adultCount;
    }, 0);

    const childrenPrice = favourites.reduce((total, favourite) => {
      return total + (favourite.priceChild ? Number(favourite.priceChild) : 0) * childrenCount;
    }, 0);

    setTotalPrice(adultPrice + childrenPrice);
  };

  useEffect(() => {
    updateTotalPrice();
  }, [adultCount, childrenCount, favourites]);

  if(isCalculatorExpanded){
    return (
        <div className='calculator-container-base'>
          <div className="favourite-attractions">
            <div className="calculator-header">
              {t("CALCULATOR_title").toUpperCase()}
              <div onClick={()=>{setIsCalculatorVisible(false)}} className='close-calculator-container'>x</div>
            </div>
            <div className={favourites.length === 0 ? "calculator-content" : "calculator-content-filled"}>
              {favourites.length === 0 ? (
                <div className="placeholder">
                  {t("CALCULATOR_tip")}
                </div>
              ) : (
                <ul style={{ padding: "0px 0px", alignItems: 'center', width: "100%", justifyContent: 'center', display: "flex", flexDirection: 'column', marginTop: 0 }}>
                  <p style={{ textAlign: 'right', width: '100%', height: '10px', marginTop: 1, marginRight: 10 }}>
                    {t("CALC_NORMAL_ADULT_PRICE")}
                  </p>
                  {favourites.map((favourite, index) => (
                    <div key={index} style={{ alignSelf: 'center', backgroundColor: 'white', width: "96%", height: '30px', flexDirection: "row", display: "flex", justifyContent: "space-between", alignItems: "center", paddingLeft: 5, paddingRight: 5 }}>
                      <p className="truncated-text">
                        {capitalizeTitle(favourite.content[languageStore.selectedLanguage]?.title)}
                      </p>
                      {favourite?.priceAdult ? 
                        <span>
                          {favourite.priceAdult} Kč
                        </span>
                        :
                        null
                      }
                      <span style={{ color: 'gray' }} onClick={() => onRemoveFavourite(favourite._id)}>×</span>
                    </div>
                  ))}
                </ul>
              )}
            </div>
            {isCheckSavingTrue && (
              <div className="day-pass-selector">
                <div className="passes">
                {passes.map((pass, index) => {
                  return (
                    <button
                      key={index}
                      className={`pass-button ${selectedPass === index ? 'selected' : ''}`}
                      onClick={() => {
                        setSelectedPass(index);
                        setSelectedPassesIndex(index);
                      }}
                    >
                      {pass}
                    </button>
                  );
                })}
                </div>
                {selectedPass !== null && (
                  <div className="details">
                    <div className="ticket-type">
                      <span>{t("CALC_ADULT")}</span>
                      <div className="quantity-selector">
                        <button onClick={() => setAdultCount(adultCount > 0 ? adultCount - 1 : 0)}>-</button>
                        <span>{adultCount}</span>
                        <button onClick={() => setAdultCount(adultCount + 1)}>+</button>
                      </div>
                    </div>
                    <div className="ticket-type">
                      <span>{t("APP_STUDENT_CHILD")}</span>
                      <div className="quantity-selector">
                        <button onClick={() => setChildrenCount(childrenCount > 0 ? childrenCount - 1 : 0)}>-</button>
                        <span>{childrenCount}</span>
                        <button onClick={() => setChildrenCount(childrenCount + 1)}>+</button>
                      </div>
                    </div>
                  </div>
                )}
                {isCheckContinueTrue &&(
                  <div className="savings-layout">
                    <div className="savings-card">
                      <div className="total-price">
                        <span>{t("CALCULATOR_total_entry_prices_cost")}</span>
                        <span>{totalPrice} Kč</span>
                      </div>
                      <div className="coolpass-price">
                        <span>{t("CALCULATOR_cost_with_coolpass")}</span>
                        <span>{((adultCount * 1600) + (childrenCount * 1200)) + (selectedPassesIndex?(adultCount * passesAdult[selectedPassesIndex] + childrenCount * passesChild[selectedPassesIndex]):0)} Kč</span>
                      </div>
                      <div className="you-save">
                        <span>{t("CALCULATOR_you_save_label")}</span>
                        <span style={{ color: 'green' }}>{totalPrice > 1875 ? totalPrice - 1875 : 0} Kč</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            
            <div className="calculator-only-footer">
            {favourites.length > 0 && (
              <div>
                <p onClick={() => {clearAllLikes(); setIsCheckSavingTrue(false); setIsCheckContinueTrue(false)}} className="clear-button">{t("CALCULATOR_CLEAR")}</p>
              </div>
            )}
              <button 
                className="savings-button"
                disabled={favourites.length === 0}
                onClick={() => {
                  setIsCheckSavingTrue(true);
                  if (isCheckSavingTrue){
                    setIsCheckContinueTrue(true)
                  }
                  if(isCheckContinueTrue){
                    navigate('/under-construction');
                  }
                }}
                >{isCheckContinueTrue ? 
                    (t("CALCULATOR_order_your_coolpass").toUpperCase()) 
                    :
                    (
                      isCheckSavingTrue ?
                      (t("CALCULATOR_continue_btn").toUpperCase())
                      :
                      (t("CALCULATOR_check_my_savings_btn").toUpperCase())
                    )
                  }
                </button>
            </div>
          </div>
        </div>
      );
  }else{
    return(
        <div className='calculator-only-footer'>
            <button 
                className="my-favs-button"
                disabled={favourites.length === 0}
                onClick={() => {
                  setIsCalculatorVisible(true);
                }}
                >
                  <p style={{fontWeight:500, justifySelf: 'center',}}>{t("CALCULATOR_title")}</p>
                  <p style={{fontWeight:'bold', color:'#51ae28', justifySelf: 'center', alignContent: 'center'}}>{favourites.length}</p>              
                </button>
              <button 
                className="savings-button"
                disabled={favourites.length === 0}
                onClick={() => {
                  setIsCheckSavingTrue(true);
                  if (isCheckSavingTrue){
                    setIsCheckContinueTrue(true)
                  }
                  if(isCheckContinueTrue){
                    navigate('/under-construction');
                  }
                }}
                >{isCheckContinueTrue ? 
                    (t("CALCULATOR_order_your_coolpass").toUpperCase()) 
                    :
                    (
                      isCheckSavingTrue ?
                      (t("CALCULATOR_continue_btn").toUpperCase())
                      :
                      (t("CALCULATOR_check_my_savings_btn").toUpperCase())
                    )
                  }
                </button>
        </div>
    )
  }
  
};

export default CalculatorMobile;
